import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsradiology',
  templateUrl: './asahsradiology.component.html',
  styleUrls: ['./asahsradiology.component.scss']
})
export class AsahsradiologyComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
